<template>
   <div>
    <div class="notification-panel-wrapper">
        <div class="close-or-min-panel" :style="!openNotificationSettings?'justify-content: space-between':'justify-content: start'">
            <div v-if='openNotificationSettings' class="back-button-wrapper"><back-icon v-on:click.native="openNotificationSettings = false"></back-icon></div>
            <div class='d-flex'>
                <div style="text-align:start;padding: 9px;font-size: 24px;">{{$t('Notifications')}}</div>
            </div>
            <div v-if="!openNotificationSettings" v-on:click="closeUserNotifications()" style="display:flex;align-items:center">
                 <cancelIcon style="height: 34px;
                    width: 40px;"></cancelIcon>
            </div>
        </div>
        <div v-if='!openNotificationSettings' class="configuration-panel">
            <div class="select-filters">
                <div :class="{activeFilter:selectedFilter == 'all'}" @click="changeFilter('all')" class="notification-filters">All</div>
                <div :class="{activeFilter:selectedFilter == 'mentions'}" @click="changeFilter('mentions')" class="notification-filters">@ mentions</div>
            </div>
            <div style="display:flex">
                <button class="learn-about-text-styles" @click="updateNotificationStatus(true)" >
                    {{$t('Mark all as read')}}</button>
                
                <div class="nav-item dropdown show">
                    <a class="nav-item nav-link dropdown-toggle mr-md-2 icon-background-on-hover" id="bd-versions" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" style="padding:5px;margin-inline-end:0px !important">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#8d8d8d" class="bi bi-three-dots-vertical" viewBox="0 0 16 16">
                            <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                        </svg>
                    </a>
                  <div class="dropdown-menu dropdown-menu-md-right p-0" aria-labelledby="bd-versions">
                    <a @click="openNotificationSettings = true;constructNotificationSettings()" class="dropdown-item p-2" style="position:relative;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-gear-fill" viewBox="0 0 16 16">
                            <path d="M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872l-.1-.34zM8 10.93a2.929 2.929 0 1 1 0-5.86 2.929 2.929 0 0 1 0 5.858z"/>
                            <title>{{$t('Configure notifications')}}</title>
                        </svg> {{$t('Configure')}}
                    </a>
                  </div>
                </div>
            </div>
        </div>
        <div v-if="!openNotificationSettings" v-on:scroll="loadMoreNotifications($event)" class="notification-display-wrapper">
            <!-- <div v-for="nItem in notificationsList" :key='nItem._id'  :style='!nItem.access_log.includes(getLoggedInUserId())?"background:#16323d40":""' class='notification-display-sub-wrapper'> -->
               <!-- <router-link :to="{ name: getRouterNameType(nItem), params: getRouteParams(nItem.message), query:Object.assign({}, $route.query)}" v-for="nItem in notificationsList" :key='nItem._id' v-on:click.native='updateNotificationStatus(false, nItem._id)' :style='!nItem.access_log.includes(getLoggedInUserId())?"background:#16323d40":""' class='notification-display-sub-wrapper'> -->
            <template v-if="notificationsList.length">
                <div v-for="nItem in notificationsList" :key='nItem._id' v-on:click='updateNotificationStatus(false, nItem._id,!nItem.access_log.includes(getLoggedInUserId()));redirectToRespectivePage(nItem)' :style='!nItem.access_log.includes(getLoggedInUserId())?"background:#16323d40":""' class='notification-display-sub-wrapper'>
                    <div class='p-0' style="display: flex;align-items: flex-start;width:12%;position:relative">
                        <div v-if="nItem.message_from_prof_img" class='user-name-or-image' style="margin-inline-end: 9px;">
                            <img  :src="getThumbnailConvertedPath(nItem.message_from_prof_img)" @error="replaceWithUserIcon($event,nItem.message_from_name,nItem._id)" style="width:100%;height:100%;border-radius:6px;margin-bottom: 5px">
                        </div>
                        <div v-else class="user-name-or-image user-name" :title='nItem.message_from_name' :style="style(nItem.message_from_name)">{{ nItem.message_from_name.split("")[0] }}
                        </div>
                    </div>
                    <div class='pl-1 p-0 notification-title' style="width:88%">
                        <div v-if="nItem.message_context == 'Generate SRT'">
                            SRT file is available for 
                            <a style="color:#EEEEEE" class="link" @click="downloadSRTFile(nItem.message)">{{nItem.message.slug_name}}</a>
                        </div>
                        <div v-else v-html="detectLinkAndIds(nItem)" style="width: 90%;"></div>
                        <div v-if="Object.keys(nItem.message).includes('comment')" style="color:#ababab">{{nItem.message.comment.substring(0,250)}} <span v-if="nItem.message.comment.length > 250">...</span></div>
                        <template v-if="'file_info' in nItem.message">
                            <div v-for="file in nItem.message.file_info" :key="file._id" class="attachments-in-notifications">
                                <div v-if="Object.keys(file).includes('proxy_info') && Object.keys(file.proxy_info).includes('thumbnail_uri')" class="thumbnail-view" style="width:155px;height:140px;margin-top:10px;justify-content: center;" >
                                    <div style="position:relative">
                                        <img  :src="getThumbnailPath(file)" @error="replaceByDefaultImage" class='w-100' style="border-radius: 5px;">
                                        <div v-if="file.markers" class="storage-type-bottom-icons-wrapper">
                                            <div style="position:relative;inset-inline-start:4px">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#1af3ff" class="bi bi-input-cursor" viewBox="0 0 16 16">
                                                    <path d="M10 5h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4v1h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4v1zM6 5V4H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v-1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4z"/>
                                                    <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13A.5.5 0 0 1 8 1z"/>
                                                <title>{{$t('Subclip')}}</title>
                                                </svg>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#1af3ff" class="bi bi-input-cursor" viewBox="0 0 16 16" style="position: absolute;inset-inline-end :10px;top:3px;">
                                                    <path d="M10 5h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4v1h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4v1zM6 5V4H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v-1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4z"/>
                                                    <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13A.5.5 0 0 1 8 1z"/>
                                                <title>{{$t('Subclip')}}</title>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="'slug_name' in file" style="display:flex;" :title="file.slug_name">
                                        <div class="svg-icons-display" v-html="getSvgIconsOfMediaTypes(file)">
                                        </div>
                                        <div style=" margin-top: 7px; text-align: start;white-space: nowrap;width: 100%;overflow: hidden;text-overflow: ellipsis;font-size:12px;margin:9px;margin-inline-start:0px">
                                            {{file.slug_name}}
                                        </div>
                                    </div>
                                    <div v-else style="display:flex;" :title="file.proxy_info.file_name">
                                        <div class="svg-icons-display" v-html="getSvgIconsOfMediaTypes(file)">
                                        </div>
                                        <div style=" margin-top: 7px; text-align: start;white-space: nowrap;width: 100%;overflow: hidden;text-overflow: ellipsis;font-size:12px;margin:9px;margin-inline-start:0px">
                                            {{file.file_name}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <preview v-if="nItem.message.task_type" :previewDataFromParent="nItem.message" :disbaleRedirect="false"></preview>
                        <div class='dull-text-display'>{{getDateAndTimeInConfiguredFormat(nItem.created_datetime)}}</div>
                    </div>
                    <div v-if="!nItem.access_log.includes(getLoggedInUserId())" title="New" class='new-notification' v-on:click.stop.prevent='updateNotificationStatus(false, nItem._id)'></div>
                    <div v-if="nItem.scope == 'mentions'" class='mentioned-you' title="Mentioned you" v-on:click.stop.prevent='updateNotificationStatus(false, nItem._id)'>@</div>
                </div>
            </template>

            <div v-if="!notificationsList.length" class="outer">
                <div class="middle">
                    <div class="inner">
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="#666" class="bi bi-bell-fill" viewBox="0 0 16 16">
                            <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zm.995-14.901a1 1 0 1 0-1.99 0A5.002 5.002 0 0 0 3 6c0 1.098-.5 6-2 7h14c-1.5-1-2-5.902-2-7 0-2.42-1.72-4.44-4.005-4.901z"/>
                        </svg>
                        <p>{{$t('No notifications yet')}}!!</p>
                    </div>
                </div>
            </div>
            <!-- </div> -->
        </div>
        <div v-else class="notification-display-wrapper">
            <ul class="notification-configuration-ul">
                <li v-for="item in configureNotifications" :key='item.context'>
                    <div>
                        <div>{{item.context}}</div>
                        <!-- <div class='dull-text-display'>{{item.description}}</div> -->
                    </div>
                    <div class="custom-control custom-switch" style="width:unset">
                        <input v-on:click="updateNotifications(item,$event.target.checked)" :checked="item.state == 'enabled' " type="checkbox" class="custom-control-input" :id='item.context'>
                        <label class="custom-control-label" for="customSwitch1"></label>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <OCBrowse v-if="isOpenInCatalogBrowse" @close="isOpenInCatalogBrowse = false" :pIPList="parentPathList" @traverToCatalog="handleMultipleCatalog"></OCBrowse>
   </div>
</template>

<script>
import Utils from "../../components.utils.js";
import {mapGetters, mapActions, mapMutations} from "vuex";
import BackButton from "../core/backButton.vue";
import Constants from "../../components.constants.js"
import cancelIcon from "../core/InlineCancelField.vue";
import { NotifierConstants } from '../../components.constants.js';
import tasksPreview from "../core/PreviewUrl.vue";
import OCBrowse from '../categories/OpenInCatalogBrowse.vue';
import axios from "axios";

export default {
    components:{
        'back-icon':BackButton,
        'cancelIcon':cancelIcon,
        'preview':tasksPreview,
        OCBrowse
    },
    data(){
        return{
            openNotificationSettings:false,
            configureNotifications:[],
            notificationsList:[],
            currentPage:1,
            page: 1,
            totalPages: -1,
            totalNotifications: -1,
            perPage: -1,
            unsetReadStatus:false,
            selectedFilter:"all",
            hovered:false,
            isOpenInCatalogBrowse: false,
            parentPathList:[],
        }
    },
    methods:{
        getThumbnailConvertedPath(image_url){
            return Utils.convertToLoginIPDomainName(image_url);
        },
        setOpenInMultipleCatalogsData(message){
             let plist = [];
             for(let i = 0; i < message.parent_path.length; i++){
                 let splitL = String(message.parent_path[i].value).split('/');
                 let catalogName = splitL[splitL.length - 1];
                 let catalogIdSplit = String(message.parent_path[i].id).split('/');
                 let id = catalogIdSplit[catalogIdSplit.length - 1];
                 plist.push({
                    parent_path: message.parent_path[i],
                    parent_id_path: [message.parent_path[i].id],
                    _id: id,
                    catalog_name:catalogName,
                 })
             }
             this.parentPathList = plist;
        },
        handleMultipleCatalog(catalogId){
            this.$router.push({
                name:'catalogs-display',
                params:{catalog_id:catalogId}
            });

            this.isOpenInCatalogBrowse = false;
        },
        getThumbnailPath(file) {
            return Utils.getThumbnailPathfromFileInfo(file);
        },
        style(name){
            let style = {
                'color':Utils.textColor(Utils.intToRGB(Utils.hashCode(name))),
                'background-color':'#'+Utils.intToRGB(Utils.hashCode(name))
            }
            return style
        },
        checkUnreadNotifications(isRead){
            if(!this.unsetReadStatus){
                if(isRead){
                    return true;
                }
                return false;
            }
            return false;
        },
        changeFilter(type){
            localStorage.setItem("selected-notification-filter",type);
            this.selectedFilter = localStorage.getItem("selected-notification-filter");
            this.constructNotifications();
        },
        detectLinkAndIds(item){
            let tagKey = item.message.task_tag 
            if (!item.message.task_tag){
                if('review_tag' in item.message){
                    tagKey = item.message.review_tag;
                }else if('qc_tag' in item.message){
                    tagKey = item.message.qc_tag;
                }
            }
           
            if(tagKey){
                return item.header.replace(tagKey, function(b) {
                    return '<a style="color:#1d9bd1" class="link">' + b + '</a>';
                })
            }else if(item.message.receiver_name && item.message.receiver_type && item.message.receiver_type == 'group'){
                return item.header.replace(item.message.receiver_name, function(b) {
                    return '<span style="color:#1d9bd1" class="link">#' + b + '</span>';
                })
            }else{
                return item.header;
            }
        },
        downloadSRTFile(notificationMessage) {
            const fileUrl = notificationMessage.srt_path

            // Create a link element
            const link = document.createElement("a");
            link.download = new URL(fileUrl).pathname.split('/').pop();
            link.href = fileUrl;

            // Trigger a click event on the link to start the download
            link.click();
        },
        checkWhetherSRTDownload(item){
             if(item && Object.prototype.hasOwnProperty.call(item,'message_context') && item.message_context == 'Transcript'){
                 if(item.message && item.message.catalog_id_path && item.message.catalog_id_path.length){
                     if(item.message.catalog_id_path.length == 1){
                         let splitL = item.message.catalog_id_path[0].split('/');
                         let catId = splitL[splitL.length - 1];
                         return {isLocationInfo: true, 
                          isMultiple: false,
                          routeParams:{
                             name:'catalogs-display',
                             params:{catalog_id:catId}
                         }};
                     }else{
                        this.setOpenInMultipleCatalogsData(item.message);
                        return {
                            isLocationInfo: true,
                            isMultiple: true,
                        }
                     }
                 }
             }
             return {isLocationInfo: false}
        },
        async redirectToRespectivePage(item){
            console.log("redirectToRespectivePage redirectToRespectivePage",item);
            if(item && ['Generate SRT'].includes(item.message_context)){
                return
            }
            if(item && Object.prototype.hasOwnProperty.call(item,'mapped_privilege') && String(item.mapped_privilege).toLowerCase() == 'projects'){
                const loadPAMplugin = async()=>{
                        return new Promise((resolve)=>{
                            let pamPlugin = null;
                            for(let pluginId in this.getRegisteredPluginMapper()){
                                pamPlugin = this.getRegisteredPluginMapper()[pluginId];
                                if(pamPlugin && pamPlugin.name == 'PAM'){
                                    break;
                                }
                            }
                            if(pamPlugin && pamPlugin.getAlldependentPluginBundles){
                                pamPlugin.getAlldependentPluginBundles(()=>resolve());
                            }else{
                                resolve();
                            }
                        });
                }

                await loadPAMplugin();

            }
            if(item && Object.prototype.hasOwnProperty.call(item,'message_context') && item.message_context == 'Chat'){
                const loadChatPlugin = async()=>{
                        return new Promise((resolve)=>{
                            let pamPlugin = null;
                            for(let pluginId in this.getRegisteredPluginMapper()){
                                pamPlugin = this.getRegisteredPluginMapper()[pluginId];
                                if(pamPlugin && pamPlugin.name == 'Chat Pro'){
                                    break;
                                }
                                if(pamPlugin && pamPlugin.name == 'Chat'){ //for chat plugin both cannot be installed at the same time
                                    break;
                                }
                            }
                            if(pamPlugin && pamPlugin.loadChatPlugin){
                                pamPlugin.loadChatPlugin(()=>resolve());
                            }else{
                                resolve();
                            }
                        });
                }
                await loadChatPlugin();

            }

            if(item && Object.prototype.hasOwnProperty.call(item,'message_context') && String(item.message_context).toLocaleLowerCase() == 'review'){
                const loadReviewPlugin = async()=>{
                        return new Promise((resolve)=>{
                            let reviewPlugin = null;
                            for(let pluginId in this.getRegisteredPluginMapper()){
                                reviewPlugin = this.getRegisteredPluginMapper()[pluginId];
                                if(reviewPlugin && reviewPlugin.name == 'Review'){
                                    break;
                                }
                            }
                            if(reviewPlugin && reviewPlugin.clickHandler){
                                reviewPlugin.clickHandler.handler();
                                setTimeout(()=>{
                                    resolve();
                                },200);
                            }else{
                                resolve();
                            }
                        });
                }

                await loadReviewPlugin();

            }

            if(item && Object.prototype.hasOwnProperty.call(item,'message_context') && String(item.message_context).toLocaleLowerCase() == 'fusion_pages'){
                if(Object.prototype.hasOwnProperty.call(item.message,'file_path') && Object.prototype.hasOwnProperty.call(item.message,'file_name')){
                    this.downloadPDF(item.message.file_path, item.message.file_name);
                    return;
                } else {
                    console.error("Missing file path or filename in notification");
                    return;
                }
            }

            if(item && Object.prototype.hasOwnProperty.call(item,'message_context')){ // Bell notification handler which gives control to plugin side
                 for(let pluginId in this.getRegisteredPluginMapper()){
                    let pluginInfo = this.getRegisteredPluginMapper()[pluginId];
                    if(pluginInfo && Object.prototype.hasOwnProperty.call(pluginInfo,'bellNotificationRedirectInfo') 
                        && pluginInfo.bellNotificationRedirectInfo.message_context.includes(item.message_context)){
                         pluginInfo.bellNotificationRedirectInfo.loadPluginFunction(()=>{
                            console.log(`[Plugin][Bundle][Loaded][${pluginInfo.name}]`);
                            pluginInfo.bellNotificationRedirectInfo.handler(this,item); // call the handle function at plugin side
                         });
                        return;
                    }
                 }
            }
            

            try{
                let routeComponentName = this.getRouterNameType(item);
                let routeUrl = new URL(item.url).pathname; 
                let resolvedRouteObj = this.$router.resolve({path:routeUrl});
                if(resolvedRouteObj  && !resolvedRouteObj.resolved.matched.length){
                    this.$parent.loadFusionParams = {fullPath:routeUrl};
                    let componentInfo = Utils.getPluginNameFromPluginComponent(routeUrl,this.getRegisteredQuickAccessPannel());
                    if(componentInfo)
                       this.$parent.loadExternalWorkspacePlugin(componentInfo,routeComponentName,{},true);
                    return;
                }
            }catch(e){
                console.log(e);
            }
            try{
                let info = this.checkWhetherSRTDownload(item);
                if(info && info.isLocationInfo){
                    if(!info.isMultiple){
                        return this.$router.push(info.routeParams);
                    }else{ // multiple catalogs
                       this.isOpenInCatalogBrowse = true;
                    }
                }
            }catch(e){console.log(e)}
            let route = {name: this.getRouterNameType(item)}
            route.params = await this.getRouteParams(item.message);
            route.query = await this.getRouteQuery(item.message);
            this.$router.push(route)
        },
        downloadPDF(path, filename) {
          axios.post(
              Constants.downloadPDFURL,
              { path, filename },
              { responseType: "blob" }
          )
          .then((response) => {
              const blob = new Blob([response.data], { 
                  type: response.headers["content-type"] 
              });
              const link = document.createElement("a");
              
              const cd = response.headers["content-disposition"] || "";
              const match = cd.match(/filename="?([^"]+)"?/);
              const serverFileName = match ? match[1] : filename;
        
              link.href = URL.createObjectURL(blob);
              link.download = serverFileName;
              link.click();
          })
          .catch(console.error);
        },
        getRouterNameType(item){
            let typeCheck = item.message_context;
            let splitUrl = '';
            if(typeCheck == 'Projects'){
                splitUrl = item.url.split("/");
            }

            if(Object.keys(item.message).includes('review_tag')){
                return 'update-review'
            }else if(typeCheck == 'Share'){
                return 'share-display'
            }
            else if(['Upload','Download','Retrieve','bins-workspace','catalogs-workspace', 'Manage Media Pipeline Reports', 'dam-core-routes', 'reports'].includes(typeCheck)){
                return 'catalogs-display'
            }else if(typeCheck == 'Media Pipeline'){
                return 'media-pipeline-stage'
            }
            else if(typeCheck == 'Chat' && Object.keys(item.message).includes('receiver_name')){
                return 'chat-display'
            }else if(splitUrl.includes("users") && typeCheck == 'Projects'){
                return 'users-projects';
            }else if(splitUrl.includes("issues") || typeCheck == 'Projects'){
               return 'tasks-window';  
            }else if(splitUrl.includes("tasks") || typeCheck == 'Projects'){
                return 'tasks-window';  
            }else if(item.message.task_type == "Ticket" || typeCheck == 'Ticket'){
                return 'tasks-window';
            }else if(this.$route.name == 'users-projects'){
                if(splitUrl.includes("issues") || typeCheck == 'Projects'){
                    return 'tasks-window';
                }else if(splitUrl.includes("tasks") || typeCheck == 'Projects'){
                    return 'tasks-window';
                }else if(this.message.task_type == "Ticket"){
                    return 'tasks-window';
                }
            } else{
                return false;
            }
        },
        async getRouteParams(item){
            if(Object.keys(item).includes('catalog_id')){
                return {
                    _id: item.catalog_id, 
                    catalog_name:item.catalog_name, 
                    catalog_id:item.catalog_id,
                    parentinfo:Object.assign({forceRedirect:true},this.$route),
                    fromNotification:true}
            }else if(Object.keys(item).includes('review_tag')){
                return {reviewId: item.review_tag, tabType:'cm', parentinfo:Object.assign({forceRedirect:true},this.$route)}
            }else if(Object.keys(item).includes('project_user_type') && Object.keys(item).includes('project_id')){
                return {projectId:item.project_id, parentinfo:Object.assign({forceRedirect:true},this.$route)}
            }else if(Object.keys(item).includes('task_tag')){
                if("project_id" in item){
                    return {taskId: item.task_tag, tabType:'cm', projectId:item.project_id, parentinfo:Object.assign({forceRedirect:true},this.$route)}
                }else{
                    let taskId = item.task_tag;
                    if(taskId){
                        let payload = {};
                        payload.taskType = "Task";
                        payload.taskId = taskId;
                        let projectId = null;
                        await this.getServerIndTaskData(payload).then((data) =>{
                            projectId = data["task"].project_id;
                        });
                        // this.$nextTick(() => {
                            return {taskId: item.task_tag, tabType:'cm', projectId:projectId, parentinfo:Object.assign({forceRedirect:true},this.$route)};
                        // });
                    }    
                }
            }else if(Object.keys(item).includes('receiver_name')){
                return {resource: item.receiver_type == 'group'?'ch':'dm',
                              recipientId: item.receiver_type == 'group'?item.receiver_id:item.sender_id,
                              commentId: item.pid=="0"?item._id:item.pid, parentinfo:Object.assign({forceRedirect:true},this.$route)}
            }else{
                return false;
            }
        },
        async getRouteQuery(item){
            if(Object.keys(item).includes('catalog_id')){
                return {advanceFilter:JSON.stringify({fields:JSON.stringify({}), asset_id:item.asset_id})}
            }if(Object.keys(item).includes('stage_id')){
                return {id:item.stage_id,advanceFilter:JSON.stringify({fields:JSON.stringify({}), asset_id:item.asset_id})}
            }else{
                return Object.assign({},this.$route.query);
            }
        },      
        getSvgIconsOfMediaTypes(path, type) {
            return Utils.determineSvgIconForType(path, type);
        },
        getProfileImageOfUser(image){
            let profileImageTag = '<img src='+this.getProxyConvertedURL(image)+' style="width:100%;height:100%;border-radius:6px">';
            return profileImageTag;
        },
        replaceWithUserIcon(e){
            e.target.onerror = null
            e.target.src = Utils.getNoThumbnailImg();
        },
        closeUserNotifications(){
            this.$emit("closeNotificationPanel")
        },
        updateNotifications(item,isChecked){
            let payload = {"context": item.context}
            if(isChecked){
                payload.state = "enabled"
            }else{
                payload.state = "disabled"
            }
            this.updateNotificationSettings(payload).then(() => {
                // based on this function update state as enabled/disabled for the context
                return
            })
        },
        updateNotificationStatus(mark_all_read, itemId=null, isNotRead = true){
            if(!isNotRead){
                return false;
            }
            let payload = {}
            if (mark_all_read == true){
                payload.mark_all_as_read = true;
                // payload.scope="";
            }else if (itemId && itemId != null){
                payload._id = itemId
            }
            this.updateNotificationAsRead(payload).then(() => {
                // based on this function access log , if logged in user_id in present inside access log for notif, then remove the unread dot
                if(mark_all_read){
                    this.constructNotifications()
                }
                let index = this.notificationsList.findIndex(e => e._id == itemId);
                if(index > -1){
                    this.notificationsList[index]["access_log"].push(this.getLoggedInUserId())
                }
                return
            })
        },
        constructNotifications(isLoadMore = false){
            let payload = {params:{}};
            if(this.selectedFilter == 'mentions'){
              payload.params = {"scope": "mentions"}
            }
            payload.params.page = isLoadMore?this.currentPage:1;
            this.getAllUserNotificationsFromServer(payload).then((data) =>{
                if(isLoadMore){
                    this.notificationsList = this.notificationsList.concat(data["notifications"]);
                }else{
                    this.notificationsList = data["notifications"];
                }
            
                this.totalPages = data["page_count"];
                this.currentPage = data["page"];
                this.page = data["page"];
                this.totalNotifications = data["total_notifications"];
                this.perPage = data["notifications_per_page"];
            });    
        },
        loadMoreNotifications(e){
            if (e.target.offsetHeight + e.target.scrollTop >= e.target.scrollHeight) {
                if(this.currentPage < this.totalPages){
                    this.currentPage = this.currentPage + 1;
                    this.constructNotifications(true);
                }else{
                    return false;
                }
            }
        },
        replaceByDefaultImage(e){
            e.target.onerror = null
            e.target.src = Utils.getNoThumbnailImg();
        },
        constructNotificationSettings(){
            this.getSessionUserNotifSettings().then((data) =>{
                if (data["notification_settings"]){
                    this.configureNotifications = data["notification_settings"]["plugin_configurations"]
                }
            });    
        },
        handleUserNotification(notification){
            notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification;
                if(this.selectedFilter == 'mentions'){
                    if(notification.message.scope == 'mentions' && notification.message.message_to.includes(this.getLoggedInUserId())){
                        this.notificationsList.unshift(notification.message);
                    }   
                }else{
                    if(notification.message.message_to.includes(this.getLoggedInUserId())){
                        this.notificationsList.unshift(notification.message);
                    }
                }
        },
        ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
        ...mapActions("users", ["getAllUserNotificationsFromServer", "updateNotificationAsRead","getSessionUserNotifSettings", "updateNotificationSettings"]),
        ...mapActions("PAM",["getServerIndTaskData"]),
        ...mapGetters("users",["getLoggedInUser","getLoggedInUserId"]),
        ...mapGetters("registry",["getRegisteredQuickAccessPannel","getRegisteredPluginMapper"]),

    },
    mounted(){
        this.addWSEventListener({eventname:NotifierConstants.userNotificationCreated, callback:this.handleUserNotification, parent:"UserNotification"});
    },
    created(){
        this.selectedFilter = localStorage.getItem("selected-notification-filter");
        if(!this.selectedFilter){
            this.selectedFilter = 'all';
            localStorage.setItem("selected-notification-filter",'all');
        }
        this.constructNotificationSettings()
        this.constructNotifications(false);
    },
    beforeDestroy(){
        this.removeWSEventListener({eventname:NotifierConstants.userNotificationCreated, callback:this.handleUserNotification, parent:"UserNotification"});   
    }
}
</script>

<style scoped lang="scss">
$table-row-border: none;
$secondary-blue-color: #00a1ff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;
$icon-hover:#2c3339;
$count-bg-color:#e7c20b;
$brighter-border: 1px solid #5a5a5a;
$input-field-padding:.375rem 10px;
$tag-color: #18a6db;
$count-border-color:#373737;

.active{
    color:$active-blue;
}

.dull-text-display{
    color:$dull-text-color !important;
    font-size: 12px;
}

.filters-bar{
    max-height: 190px;
    width: 100%;
    overflow:auto;
    display:inline-block;
    ul{
        list-style-type: none;
        padding-inline-start:2px;
        li{
            text-align: start;
            margin-inline-start: 6%;
            margin-top: 9px;
        }
    }
}
.notification-panel-wrapper{
    width: 450px;
    border: 1px solid #3a3a3a;
    position: absolute;
    background: $secondary-background-color;
    bottom: 1px !important;
    top:unset !important;
    inset-inline-end: 1px;
    z-index: 999;
    height: 100%;
    box-shadow: 1px 2px 32px 4px rgba(0,0,0,0.63);
    -webkit-box-shadow: 1px 2px 32px 4px rgba(0,0,0,0.63);
    -moz-box-shadow: 1px 2px 32px 4px rgba(0,0,0,0.63);
    .close-or-min-panel{
            height: 65px;
            width:100%;
            border-bottom: $secondary-border-color;
            background: $secondary-background-color;
            text-align: end;
            padding: 5px;
            display: flex;
            justify-content: space-between;
        }
        .configuration-panel{
            height: 40px;
            width:100%;
            background: $secondary-background-color;
            text-align: end;
            padding: 5px;
            display: flex;
            justify-content: space-between;
            .learn-about-text-styles{
                padding-top:5px;
            }
        }
    .notification-display-wrapper{
            height:83%;
            width: 100%;
            padding-top: 7px;
            overflow:auto;
            display:inline-block;
            .edit-upload-info{
                width:8%;
                padding: 5px;
                    svg{
                        position: relative;
                        inset-inline-end: 6px;
                    }
            }
            .file-name-with-progress-bar-wrapper{
                    display: inline-flex;
                    width: 93%;
                    .file-name-wrapper{
                        width: 99%;
                        display: inline-block;
                        .file-name-display{
                            text-align: start;
                            /* white-space: nowrap; */
                            overflow-wrap: break-word;
                            width: 277px;
                            /* overflow: hidden; */
                            /* text-overflow: ellipsis;*/
                            span{
                                    font-size: 11px;
                                    color: #dbdbdb;
                            }
                        }
                        .upload-status-text{
                            text-align: start;
                            float:inline-start;
                            font-size:11px;
                            margin-inline-start:8px;
                            color:#8d8d8d;
                        }
                        .progress-bar-wrapper{
                                display: inline-flex;
                                width: 100%;
                                .progress-percentage-display{
                                        font-size: 11px;
                                }
                                .progress{
                                    width: 67%;
                                    background: #292929;
                                    margin-inline-start: 4px;
                                    height: 10px;
                                    margin-top: 2px;
                                    border-radius: 3px;
                                }
                                .progress-speed-display{
                                        font-size: 11px;
                                        margin-inline-start: 3px;
                                }
                        }
                    }
                }
                .file-upload-status-display-wrapper{
                        width:20%;
                        .file-upload-status{
                            height: 30px;
                            margin-top: 8px;
                            display:inline-flex;
                        }
                    }
            }
        }


.notification-configuration{
    visibility: hidden;
    position: relative;
    inset-inline-end: 4px;
    bottom: 3px;
}

.close-or-min-panel:hover{
    .notification-configuration{
        visibility: visible;
        position: relative;
        inset-inline-end: 4px;
        bottom: 3px;
    }
}

.edit-upload-info{
    position: relative;
    inset-inline-start:0px;
}

.minHeight{
    height:52px !important;
    bottom:1px !important;
    top: unset !important;
}

.dragged-element {
    width: 100px;
    height: 100px;
    border-radius: 5px;
    font-size: 12px;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;
    text-align: center;
    transition: all 0.4s linear;
    transition-property: $primary-background;
  }

.remove-selected-file{
  visibility:hidden;
}

.upload-bars:hover{
  .remove-selected-file{
    visibility: visible;
    position: relative;
    bottom: 6px;
  }
} 
.custom-control-input{
  z-index:999;
}
.close-icon:hover{
  background: #373737;
  border-radius: 20px;
}

.upload-bars{
    margin-bottom: 12px;
}
.back-button-wrapper{
    float: inline-start;
    padding-top: 3%;
    svg{
        float: inline-start;
    }
    svg:hover{
        background: #353434 !important;
    }
}

.filterpanel{
    visibility: hidden;
}
.new-notification{
    height: 10px;
    width: 10px;
    border-radius: 10px;
    background: $count-bg-color;
    border:$count-border-color;
    position: absolute;
    inset-inline-end: 2%;
    top: 12px;
}
.notification-configuration-ul{
    height: 100%;
    overflow: auto;
    li{
        text-align: start;
        padding: 13px;
        display: flex;
        justify-content: space-between;
    } 
}
.notification-display-sub-wrapper{
    padding: 5px;
    display: flex;
    width: 100%;
    padding-inline-start: 20px !important;
    position: relative;
    min-height: 65px;
    padding: 5px;
    border-top: 1px solid #0c0c0c;
    .notification-title{
        display: flex;
        text-align: start;
        flex-direction: column;
        justify-content: center;
    }
    div{
        color:$text-color;
    }
}

.notification-display-sub-wrapper:hover{
    background: $primary-background;
    border-radius: 5px;
}


.custom-control-label::before {
  background-color: $primary-background;
}

input[type="checkbox"]:after {
  line-height: 1.5em;
  content: "";
  display: inline-block;
  width: 22px;
  height: 21px;
  margin-top: 5px;
  margin-inline-start: -1px;
  border: $border-color;
  border-radius: 0.25em;
  background: $primary-background;
}

input[type="checkbox"]:checked:after {
  content: "✔";
  color: $active-blue;
  position: absolute;
  font-size: 16px;
  line-height: 1;
  transition: all 0.2s;
  font-family: Helvetica, Arial, sans-serif;
  padding-inline-start: 4px;
  padding-top: 2px;
}

.close-or-min-panel:hover{
    .filterpanel{
        visibility: visible;
    }
}

.user-name-or-image{
    height: 40px;
    width: 40px;
    border: $border-color;
    border-radius: 10px;
    text-align: center;
    line-height: 28px;
    text-transform: uppercase;
    margin-top: 3px;
}

.user-name{
    margin-inline-end: 10px;
    position: relative;
    bottom: 7px;
    font-size: 20px;
    padding: 6px;
}

.mentioned-you{
    color: #00bdbd !important;
    position: absolute;
    inset-inline-end: 23px;
    top: 6px !important;
}

::-webkit-scrollbar {
    width: 8px;
    height:8px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: $scrollbar-track-background;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: $scrollbar-thumb-background;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: $scrollbar-thumb-on-hover-background;
  }

  .learn-about-text-styles{
  color:$learn-about-text-color;
  padding-inline-end: 5px;
  padding-inline-start: 5px;
  svg{
    margin-inline-end: 2px;
    margin-bottom: 3px;
  }
}

.learn-about-text-styles:hover{
  text-decoration: underline;
  color:$learn-about-text-color-hover;
}

.attachments-in-notifications{
    list-style-type: none;
    display: inline-flex;
    flex-wrap: wrap;
    padding: 0;
    margin-top: 0;
    width: 100%;
    justify-content: start;
    overflow: auto;
    div{
        margin: 5px;
    }
}

.svg-icons-display-wrapper{
    align-items: center;
    border: $border-color;
    border-radius: 7px;
    .svg-icons-display{
        height: 70px !important;
        width: 70px !important;
        margin: 12% auto;
    }
}

.svg-icons-display {
  height: 20px;
  width: 20px;
  position: relative;
  opacity: 0.8;
  inset-inline-end: 5px;
}

a:hover{
    text-decoration: none;
}

.notification-display-sub-wrapper:hover{
    .link{
        text-decoration: underline !important;
    }
}

.link:hover{
    text-decoration: underline;
}

.dropdown-menu{
    position: absolute;
    transform: translate3d(-33px, 31px, 0px);
    top: 0px;
    inset-inline-start: -88px;
}

.icon-background-on-hover:hover{
    svg{
        fill:$text-color !important;
    }
}

.select-filters{
    display:flex;
    .notification-filters{
        border:$border-color;
        border-radius: 20px;
        padding: 13px;
        display: flex;
        align-items: center;
        margin-inline-end: 3px;
        color: $secondary-text-color;
        // background: $tags-background-color;
    }
}

.activeFilter{
    color: #007bfc !important;
    border:1px solid #007bfc !important;
}

.outer {
  display: table;
  height: 100%;
  width: 100%;
}

.middle {
  display: table-cell;
  vertical-align: middle;
}

.inner {
  margin-inline-start: auto;
  margin-inline-end: auto;
  width: 50%;
  height: 138px;
  margin-bottom:10%;
  /* Whatever width you want */
  img{
    height:100%;
  }
  p{
    text-align: center;
    color: #666;
    font-size: 18px;
  }
}


.storage-type-bottom-icons-wrapper{
    color: #999;
    background: #1a1a1ab3;
    min-width: 40px;
    width: auto;
    inset-inline-end: -5px;
    bottom: -4px;
    border-bottom-right-radius: 4px;
    border-top-left-radius: 4px;
    position: absolute;
    display: flex;
    justify-content: center;
}
</style>



